<template>
  <div class="data-grid-search-form-input">
    <template v-if="searchColumns && searchColumns.length">
      <el-collapse-transition v-if="initSearchForm">
        <div v-show="searchExpend"
             class="form-collapse-wrap">
          <div class="form-input-wrap"
               :style="inputWrapStyle">
            <el-form ref="gridSearchForm"
                     :model="grid.search.matchMap"
                     size="mini">
              <div class="form-input-group">
                <el-row :gutter="10">
                  <el-col :span="formDimension.span"
                          v-for="(column, index) in searchColumns"
                          :key="'search_column_' + index">
                    <el-tooltip :content="column.name"
                                :enterable="false"
                                :open-delay="1000"
                                placement="top">
                      <el-form-item :prop="column._prop + '.value'">
                        <template v-if="column.inputConfig">
                          <template v-if="column.inputConfig.elementType === 'DATE_FIELD'">
                            <DataGridDatePicker v-model="grid.search.matchMap[column._prop].value"
                                                :condition.sync="grid.search.matchMap[column._prop].condition"
                                                type="daterange"
                                                range-separator="至"
                                                unlink-panels
                                                prefix-icon="el-icon-date"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="config.datetimePicker.pickerOptions"
                                                :start-placeholder="column.name + '开始'"
                                                :end-placeholder="column.name + '结束'"
                                                v-bind="$attrs"
                                                style="width: 100%">
                            </DataGridDatePicker>
                          </template>
                          <template v-else-if="column.inputConfig.elementType === 'TIME_FIELD'">
                            <DataGridTimePicker v-model="grid.search.matchMap[column._prop].value"
                                                :condition.sync="grid.search.matchMap[column._prop].condition"
                                                :placeholder="column.name"
                                                prefix-icon="el-icon-time"
                                                format="HH:mm"
                                                value-format="HH:mm"
                                                v-bind="$attrs"
                                                style="width: 100%">
                            </DataGridTimePicker>
                          </template>
                          <template v-else-if="column.inputConfig.elementType === 'DATETIME_FIELD'">
                            <DataGridDatePicker v-model="grid.search.matchMap[column._prop].value"
                                                :condition.sync="grid.search.matchMap[column._prop].condition"
                                                type="datetimerange"
                                                range-separator="至"
                                                unlink-panels
                                                prefix-icon="el-icon-date"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                :default-time="['00:00:00', '23:59:59']"
                                                :picker-options="config.datetimePicker.pickerOptions"
                                                :start-placeholder="column.name + '开始'"
                                                :end-placeholder="column.name + '结束'"
                                                v-bind="$attrs"
                                                style="width: 100%">
                            </DataGridDatePicker>
                          </template>
                          <template v-else-if="column.inputConfig.elementType === 'TIME_DETAIL_FIELD'">
                            <DataGridTimePicker v-model="grid.search.matchMap[column._prop].value"
                                                :condition.sync="grid.search.matchMap[column._prop].condition"
                                                :placeholder="column.name"
                                                prefix-icon="el-icon-time"
                                                value-format="HH:mm:ss"
                                                v-bind="$attrs"
                                                style="width: 100%">
                            </DataGridTimePicker>
                          </template>
                          <template v-else-if="column.inputConfig.elementType === 'CUSTOM_DATE_FIELD'">
                            <DataGridDatePicker v-if="column.inputConfig.inputType"
                                                v-model="grid.search.matchMap[column._prop].value"
                                                :condition.sync="grid.search.matchMap[column._prop].condition"
                                                :type="`${column.inputConfig.inputType.type}range`"
                                                range-separator="至"
                                                unlink-panels
                                                prefix-icon="el-icon-date"
                                                :default-time="['00:00:00', '23:59:59']"
                                                :format="column.inputConfig.inputType.format"
                                                :value-format="column.inputConfig.inputType.valueFormat"
                                                :picker-options="config.datetimePicker.pickerOptions"
                                                :start-placeholder="column.name + '开始'"
                                                :end-placeholder="column.name + '结束'"
                                                v-bind="$attrs"
                                                style="width: 100%">
                            </DataGridDatePicker>
                          </template>
                          <template v-else-if="column.inputConfig.elementType === 'DROP_DOWN_SELECT_LIST'">
                            <DataGridSelect v-model="grid.search.matchMap[column._prop].value"
                                            :condition.sync="grid.search.matchMap[column._prop].condition"
                                            :column="column"
                                            :key-prop="column.inputConfig.apiData.keyProp"
                                            :label-prop="column.inputConfig.apiData.valueProp"
                                            :value-prop="column.inputConfig.apiData.valueProp"
                                            :multiple="!column.inputConfig.apiData.disableMultiSearch"
                                            v-bind="$attrs">
                            </DataGridSelect>
                          </template>
                          <template v-else-if="column.inputConfig.elementType === 'DROP_DOWN_SELECT_PAGE'">
                            <DataGridSelect v-model="grid.search.matchMap[column._prop].value"
                                            :condition.sync="grid.search.matchMap[column._prop].condition"
                                            :column="column"
                                            :key-prop="column.inputConfig.apiData.keyProp"
                                            :label-prop="column.inputConfig.apiData.valueProp"
                                            :value-prop="column.inputConfig.apiData.valueProp"
                                            :multiple="!column.inputConfig.apiData.disableMultiSearch"
                                            :pageable="true"
                                            v-bind="$attrs">
                            </DataGridSelect>
                          </template>
                          <template v-else-if="column.inputConfig.elementType === 'CASCADER_SELECT'">
                            <DataGridCascader v-model="grid.search.matchMap[column._prop].value"
                                              :condition.sync="grid.search.matchMap[column._prop].condition"
                                              :column="column"
                                              :label-prop="column.inputConfig.apiData.labelProp"
                                              :value-prop="column.inputConfig.apiData.labelProp"
                                              :children-prop="column.inputConfig.apiData.childrenProp"
                                              :multiple="!column.inputConfig.apiData.disableMultiSearch"
                                              v-bind="$attrs">
                            </DataGridCascader>
                          </template>
                          <template v-else-if="column.inputConfig.acceptType">
                            <DataGridInput v-model="grid.search.matchMap[column._prop].value"
                                           :condition.sync="grid.search.matchMap[column._prop].condition"
                                           type="number"
                                           :placeholder="column.name"
                                           v-bind="$attrs"
                                           v-if="column.inputConfig.acceptType.type === 'NUMBER'"
                                           style="width: 100%"
                                           @keyup.enter.native="handleFormSearch"></DataGridInput>
                            <DataGridInput v-model="grid.search.matchMap[column._prop].value"
                                           :condition.sync="grid.search.matchMap[column._prop].condition"
                                           clearable
                                           :placeholder="column.name"
                                           v-bind="$attrs"
                                           v-else
                                           style="width: 100%"
                                           @keyup.enter.native="handleFormSearch"></DataGridInput>
                          </template>
                          <template v-else>
                            <DataGridInput v-model="grid.search.matchMap[column._prop].value"
                                           :condition.sync="grid.search.matchMap[column._prop].condition"
                                           clearable
                                           :placeholder="column.name"
                                           v-bind="$attrs"
                                           style="width: 100%"
                                           @keyup.enter.native="handleFormSearch"></DataGridInput>
                          </template>
                        </template>
                        <template v-else>
                          <DataGridInput v-model="grid.search.matchMap[column._prop].value"
                                         :condition.sync="grid.search.matchMap[column._prop].condition"
                                         clearable
                                         :placeholder="column.name"
                                         v-bind="$attrs"
                                         style="width: 100%"
                                         @keyup.enter.native="handleFormSearch"></DataGridInput>
                        </template>
                      </el-form-item>
                    </el-tooltip>
                  </el-col>
                  <el-col v-if="$scopedSlots.append && !isRowLineOver"
                          :span="isLastLineBreak ? 24 : formDimension.span">
                    <el-form-item>
                      <div class="form-button-group" :class="{'line-break': isLastLineBreak}">
                        <slot name="append"
                              :reset="resetSearchForm"></slot>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
            <div v-if="$scopedSlots.append && isRowLineOver"
                 class="row-line-over">
              <div class="form-button-group">
                <slot name="append"
                      :reset="resetSearchForm"></slot>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </template>
  </div>
</template>

<script>
import DataGridInput from './DataGridInput'
import DataGridDatePicker from './DataGridDatePicker'
import DataGridTimePicker from './DataGridTimePicker'
import DataGridSelect from './DataGridSelect'
import DataGridCascader from './DataGridCascader'
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
export default {
  name: 'DataGridSearchFormInput',
  components: {
    DataGridInput,
    DataGridDatePicker,
    DataGridTimePicker,
    DataGridSelect,
    DataGridCascader
  },
  props: {
    config: {
      required: true,
      type: Object
    },
    grid: {
      required: true,
      type: Object
    },
    searchColumns: {
      type: Array
    },
    searchExpend: {
      type: Boolean,
      default: true
    },
    maxRowLine: Number
  },
  data () {
    return {
      initSearchForm: false,
      formDimension: {
        span: null,
        cols: [1, 2, 3, 4, 6, 8, 12],
        size: 240
      }
    }
  },
  computed: {
    inputWrapStyle () {
      if (this.maxRowLine) {
        return {
          'max-height': `${this.maxRowLine * 40}px`,
          'overflow': 'auto'
        }
      }
    },
    isLastLineBreak () {
      let searchColumns = this.searchColumns
      if (searchColumns) {
        let span = this.formDimension.span
        if (span) {
          return searchColumns.length % (24 / span) === 0
        }
      }
    },
    isRowLineOver () {
      if (this.maxRowLine) {
        let searchColumns = this.searchColumns
        if (searchColumns) {
          let span = this.formDimension.span
          if (span) {
            return searchColumns.length >= this.maxRowLine * 24 / span
          }
        }
      }
    }
  },
  methods: {
    handleFormResize () {
      let formEl = this.$el
      if (formEl) {
        let formWidth = formEl.clientWidth
        if (formWidth) {
          this.formDimension.span = this.getFormResizeSpan(formWidth)
        }
      }
    },
    getFormResizeSpan (getWidth) {
      let size = this.formDimension.size
      for (let col of this.formDimension.cols) {
        let span = 24 / col
        if (span * size <= getWidth) {
          return col
        }
      }
      return 24
    },
    handleFormSearch () {
      this.$emit('search')
    },
    resetSearchForm () {
      let gridSearchForm = this.$refs['gridSearchForm']
      if (gridSearchForm) {
        gridSearchForm.resetFields()
      }
    },
    bindEvents () {
      addResizeListener(this.$el, this.handleFormResize)
    },
    unbindEvent () {
      removeResizeListener(this.$el, this.handleFormResize)
    }
  },
  mounted () {
    this.bindEvents()
    this.handleFormResize()
    this.$nextTick(() => {
      // 取消初始化过渡效果
      this.initSearchForm = true
    })
  },
  beforeDestroy () {
    this.unbindEvent()
  }
}
</script>

<style lang="scss">
  .data-grid-search-form-input {
    & > .form-collapse-wrap {
      & > .form-input-wrap {
        & > .el-form {
          .el-col {
            margin-bottom: 10px;
            height: 30px;
            overflow: visible;
          }
          & > .form-input-group {
            position: relative;
            padding: 0 15px;
            .el-form-item {
              margin-bottom: 0;
            }
            .el-date-editor {
              position: relative;
              padding-right: 2px;
              & > .el-range-separator {
                vertical-align: 1px;
              }
            }
            .el-select {
              & > .el-select__tags {
                .el-tag {
                  .el-tag__close {
                    margin-right: 5px;
                    font-size: 12px!important;
                    text-align: center;
                  }
                }
                .el-select__input {
                  font-size: 12px;
                }
              }
            }
          }
          .form-button-group {
            display: flex;
            align-items: center;
            &.line-break {
              justify-content: center;
            }
            .el-button {
              & + .el-button {
                margin-left: 10px;
              }
            }
          }
        }
        & > .row-line-over {
          position: sticky;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 10;
          background-color: #fff;
          box-shadow: 0 -6px 4px rgb(255,255,255);
          .form-button-group {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 15px 10px;
            .el-button {
              & + .el-button {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
</style>
